import {useEvent} from 'Event/EventProvider'
import {api} from 'lib/url'
import {Webhook} from 'organization/Event/WebhooksProvider'
import {useOrganization} from 'organization/OrganizationProvider'
import {useQuery} from 'react-query'

export function useWebhooks() {
  const {event} = useEvent()

  const {client} = useOrganization()

  return useQuery({
    queryKey: ['events', event.id, 'webhooks'],
    queryFn: () => client.get<Webhook[]>(api(`/events/${event.id}/webhooks`)),
  })
}
